export const dialogProps = {
  titleClassName: 'submit-dialog-header dialog-header-left',
  bodyClassName: 'submit-dialog',
  modalClassName: 'submit-dialog-content',
  actionsContainerClassName: 'submit-dialog-actions',
};
